import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'

import 'antd/dist/reset.css'
import './src/assets/style/reset.scss'
import './src/assets/style/variables-css.scss'

import './src/assets/style/common.scss'
import './src/assets/style/global.scss'

// NOTE: the global ApolloProvider was removed from here. @apollo/client (~360KB) is now created
// lazily inside the search-results chunk (src/components/Search/SearchResultsProvider.js) so it
// only loads when a visitor actually runs a search — not on every page load. Search was the only
// consumer of Apollo.

// Defer third-party scripts (GTM + Facebook Pixel) until first interaction or idle — perf.
let _tpLoaded = false
const _loadThirdParty = () => {
    if (_tpLoaded || typeof window === 'undefined') return
    _tpLoaded = true
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ platform: 'gatsby' })
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    const g = document.createElement('script')
    g.async = true
    g.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-WF3D8RH'
    document.head.appendChild(g)
    ;(function (f, b, e, v, n, t, s2) {
        if (f.fbq) return
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = v
        s2 = b.getElementsByTagName(e)[0]
        s2.parentNode.insertBefore(t, s2)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    window.fbq('init', '646394819977004')
    window.fbq('track', 'PageView')
}
export const onClientEntry = () => {
    if (typeof window === 'undefined') return
    const evs = ['scroll', 'mousemove', 'touchstart', 'keydown', 'pointerdown']
    const trigger = () => {
        _loadThirdParty()
        evs.forEach(e => window.removeEventListener(e, trigger))
    }
    evs.forEach(e => window.addEventListener(e, trigger, { passive: true }))
    setTimeout(_loadThirdParty, 10000)
}
export const onRouteUpdate = () => {
    if (typeof window !== 'undefined') {
        _fixHead()
        setTimeout(_fixHead, 0)
        setTimeout(_fixSlick, 300)
    }
    if (typeof window === 'undefined' || !_tpLoaded) return
    if (window.dataLayer) window.dataLayer.push({ event: 'gatsby-route-change' })
    if (window.fbq) window.fbq('track', 'PageView')
}


// Gatsby Head API + React 19 render SeoHead's <title>/<meta>/<link> in the SVG namespace.
// Consequences: (1) document.title (getter) only reflects an HTML-namespaced <title>, so it
// reads empty → fails the axe/Lighthouse "document-title" audit; (2) SVG-namespaced <meta>
// aren't HTMLMetaElements (no .content/.name IDL), which crashes Lighthouse/PSI's MetaElements
// gatherer → every dependent SEO + Best-Practices audit errors and both categories score 0.
// The tags are correct in the static HTML (crawlers see them); this recreates any mis-namespaced
// metadata node as a proper HTML element so the hydrated DOM PSI evaluates is correct too.
const HTML_NS = 'http://www.w3.org/1999/xhtml'
const _fixHead = () => {
    if (typeof document === 'undefined') return
    document.head.querySelectorAll('title, meta, link').forEach(el => {
        if (el.namespaceURI === HTML_NS) return
        const html = document.createElement(el.localName) // HTML namespace
        for (const a of el.attributes) html.setAttribute(a.name, a.value)
        if (el.localName === 'title') html.textContent = el.textContent
        el.replaceWith(html)
    })
    const t = document.head.querySelector('title')
    if (t && t.textContent && document.title !== t.textContent) document.title = t.textContent
}


// A11y: react-slick marks off-screen/cloned slides aria-hidden but leaves their
// links focusable. Apply `inert` to hidden slides so they leave the tab/a11y tree.
const _fixSlick = () => {
    if (typeof document === 'undefined') return
    document.querySelectorAll('.slick-slide').forEach(sl => {
        if (sl.getAttribute('aria-hidden') === 'true') sl.setAttribute('inert', '')
        else sl.removeAttribute('inert')
    })
}
export const onInitialClientRender = () => {
    _fixHead()
    setTimeout(_fixHead, 0)
    if (typeof window === 'undefined' || typeof MutationObserver === 'undefined') return
    // The Head API re-renders the (mis-namespaced) <title> after the initial commit, resetting
    // document.title. Watch <head> and re-assert the HTML title on every title mutation.
    const headMo = new MutationObserver(_fixHead)
    headMo.observe(document.head, { childList: true, subtree: true, characterData: true })
    _fixSlick()
    const mo = new MutationObserver(_fixSlick)
    mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] })
}
